<form #staffForm="ngForm" (ngSubmit)="frmData.id ? doUpdate() : doSave()" novalidate>
  <div class="row g-4">
    <div class="col-12">

      <!-- A. Personal Details -->
      <div class="form-section-card">
        <div class="fsc-header"><i class="bi bi-person-fill"></i> A. Personal Details</div>
        <div class="fsc-body">
          <div class="row g-3">
            <!-- Profile Photo -->
            <div class="col-12 d-flex align-items-center gap-4 mb-2" *ngIf="user.user_role[0].code!='spr'">
              <div class="photo-preview"
                [style.background]="frmData.profile_photo ? 'transparent' : getAvatarColor(editingId() ?? 99)">
                @if (frmData.profile_photo) {
                <img [src]="frmData.profile_photo" alt="Profile">
                } @else {
                <span>{{ frmData.first_name ? frmData.first_name[0].toUpperCase() : 'S' }}</span>
                }
              </div>
              <div>
                <label class="btn btn-outline-primary btn-sm" for="photoInput">
                  <i class="bi bi-camera-fill me-1"></i> Upload Photo
                </label>
                <input type="file" id="photoInput" class="d-none" accept="image/*" (change)="onprofile_photo($event)">
                <div class="form-text">Max Size 40KB</div>
              </div>
            </div>
            <!-- Name -->
            <div class="col-md-4">
              <label class="form-label">First Name <span class="req">*</span></label>
              <input type="text" class="form-control" name="first_name" [(ngModel)]="frmData.first_name"
                maxlength="60" placeholder="First name" [class.is-invalid]="submitted && !frmData.first_name"
                [class.is-valid]="submitted && frmData.first_name">
              <!-- @if (submitted && !frmData.first_name) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            <div class="col-md-4">
              <label class="form-label">Last Name <span class="req">*</span></label>
              <input type="text" class="form-control" name="last_name" [(ngModel)]="frmData.last_name"
                maxlength="60" placeholder="Last name" [class.is-invalid]="submitted && !frmData.last_name"
                [class.is-valid]="submitted && frmData.last_name">
              <!-- @if (submitted && !frmData.last_name) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            <div class="col-md-4">
              <label class="form-label">Emp. Code <span class="req">*</span></label>
              <input type="text" class="form-control" name="emp_code" [(ngModel)]="frmData.emp_code"
                maxlength="60" placeholder="Last name" [class.is-invalid]="submitted && !frmData.emp_code"
                [class.is-valid]="submitted && frmData.emp_code">
              <!-- @if (submitted && !frmData.emp_code) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            
            <div class="col-md-4">
              <label class="form-label">Gender <span class="req">*</span></label>
              <select class="form-select" name="gender" [(ngModel)]="frmData.gender"
                [class.is-invalid]="submitted && !frmData.gender">
                @for (g of genders; track g) { <option [value]="g">{{ g }}</option> }
              </select>
            </div>
            <!-- DOB, Blood, Nationality -->
            <div class="col-md-4">
              <label class="form-label">Date of Birth</label>
              <input type="date" class="form-control" name="dob" [(ngModel)]="frmData.dob">
              @if (frmData.dob) {
              <div class="form-text text-primary">Age: {{ calcAge(frmData.dob) }}</div>
              }
            </div>
            <div class="col-md-4">
              <label class="form-label">Blood Group</label>
              <select class="form-select" name="blood_group" [(ngModel)]="frmData.blood_group">
                <option value="">--</option>
                @for (bg of blood_groups; track bg) { <option [value]="bg">{{ bg }}</option> }
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- B. Contact & Address -->
      <div class="form-section-card">
        <div class="fsc-header"><i class="bi bi-telephone-fill"></i> B. Contact & Address</div>
        <div class="fsc-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Mobile Number <span class="req">*</span></label>
              <div class="input-group">
                <span class="input-group-text bg-light">+91</span>
                <input type="tel" class="form-control" name="mobile" [(ngModel)]="frmData.mobile"
                  pattern="^[6-9]\d{9}$" maxlength="10" placeholder="10-digit mobile"
                  [class.is-invalid]="submitted && !frmData.mobile" [class.is-valid]="submitted && frmData.mobile">
              </div>
              <!-- @if (submitted && !frmData.mobile) { <div class="text-danger small mt-1">Required.</div> } -->
            </div>
            <!-- <div class="col-md-4">
                  <label class="form-label">Alternate Mobile</label>
                  <div class="input-group">
                    <span class="input-group-text bg-light">+91</span>
                    <input type="tel" class="form-control" name="altMobile" [(ngModel)]="frmData.alternateMobile" maxlength="10" placeholder="10-digit mobile">
                  </div>
                </div> -->
            <div class="col-md-6">
              <label class="form-label">Email Address <span class="req">*</span></label>
              <input type="email" class="form-control" name="email" [(ngModel)]="frmData.email" 
                placeholder="staff@school.com" [class.is-invalid]="submitted && !frmData.email"
                [class.is-valid]="submitted && frmData.email">
              <!-- @if (submitted && !frmData.email) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            <div class="col-12">
              <label class="form-label">Residential Address</label>
              <textarea class="form-control" name="address" [(ngModel)]="frmData.address" rows="2" maxlength="300"
                placeholder="House No., Street, Colony…"></textarea>
            </div>
            <div class="col-md-4">
              <label class="form-label">City</label>
              <input type="text" class="form-control" name="city" [(ngModel)]="frmData.city" maxlength="80">
            </div>
            <div class="col-md-4">
              <label class="form-label">State</label>
              <select class="form-select" name="state" [(ngModel)]="frmData.state">
                <option value="">--</option>
                @for (s of stateOptions; track s) { <option [value]="s">{{ s }}</option> }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">PIN Code</label>
              <input type="text" class="form-control" name="pin" [(ngModel)]="frmData.pin_code" pattern="^\d{6}$"
                maxlength="6" placeholder="6-digit PIN">
            </div>
          </div>
        </div>
      </div>

      <!-- C. Professional Details -->
      <div class="form-section-card">
        <div class="fsc-header"><i class="bi bi-briefcase-fill"></i> C. Professional Details</div>
        <div class="fsc-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Staff Type <span class="req">*</span></label>
              <select class="form-select" name="staff_type" [(ngModel)]="frmData.staff_type"
                (change)="frmData.designation=''; frmData.subjects=[]" [class.is-invalid]="submitted && !frmData.staff_type">
                @for (t of staff_types; track t) { <option [value]="t">{{ t }}</option> }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Department <span class="req">*</span></label>
              <select class="form-select" name="dept" [(ngModel)]="frmData.department"
                [class.is-invalid]="submitted && !frmData.department">
                <option value="">-- Select Department --</option>
                @for (d of departments; track d) { <option [value]="d.code">{{ d.name }}</option> }
              </select>
              <!-- @if (submitted && !frmData.department) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            <div class="col-md-4">
              <label class="form-label">Designation <span class="req">*</span></label>
              <select class="form-select" name="designation" [(ngModel)]="frmData.designation"
                [class.is-invalid]="submitted && !frmData.designation">
                <option value="">-- Select Designation --</option>
                @for (d of designations; track d) { <option [value]="d.code">{{ d.name }}</option> }
              </select>
              <!-- @if (submitted && !frmData.designation) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            <div class="col-md-3">
              <label class="form-label">Employment Type <span class="req">*</span></label>
              <select class="form-select" name="empType" [(ngModel)]="frmData.employment"
                [class.is-invalid]="submitted && !frmData.employment">
                @for (e of employments; track e) { <option [value]="e">{{ e }}</option> }
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Date of Joining <span class="req">*</span></label>
              <input type="date" class="form-control" name="doj" [(ngModel)]="frmData.doj"
                [class.is-invalid]="submitted && !frmData.doj"
                [class.is-valid]="submitted && frmData.doj">
              <!-- @if (submitted && !frmData.doj) { <div class="invalid-feedback">Required.</div> } -->
            </div>
            <div class="col-md-3" *ngIf="editingId()">
              <label class="form-label">Date of Leaving</label>
              <input type="date" class="form-control" name="dol" [(ngModel)]="frmData.dol">
            </div>
            <div class="col-md-3">
              <label class="form-label">Total Experience</label>
              <input type="number" class="form-control" name="exp" [(ngModel)]="frmData.experience" min="0" max="50"
                placeholder="e.g. 5">
            </div>
            <div class="col-md-3">
              <label class="form-label">Basic Salary (₹/month)</label>
              <input type="number" class="form-control" name="salary" [(ngModel)]="frmData.basic_salary" min="0"
                placeholder="e.g. 40000">
            </div>
            <div class="col-md-3">
              <label class="form-label">Status</label>
              <select class="form-select" name="status" [(ngModel)]="frmData.status">
                @for (s of statusOptions; track s) { <option [value]="s">{{ s }}</option> }
              </select>
            </div>

            <!-- Subjects (Teaching only) -->
            @if (frmData.staff_type === 'Teaching') {
            <div class="col-12">
              <label class="form-label">Subjects Taught</label>
              <div class="subject-grid">
                @for (sub of subjectOptions; track sub) {
                <label class="subject-chip" [class.selected]="isSubjectSelected(sub.code)">
                  <input type="checkbox" class="d-none" [checked]="isSubjectSelected(sub.code)"
                    (change)="toggleSubject(sub.code)">
                  {{ sub.name }}
                </label>
                }
              </div>
            </div>
            }

          </div>
        </div>
      </div>

      <!-- D. Qualifications -->
      <div class="form-section-card" *ngIf="user.user_role[0].code!='spr'">
        <div class="fsc-header">
          <i class="bi bi-mortarboard-fill"></i> D. Educational Qualifications
        </div>

        <div class="fsc-body">
          @for (q of frmData.qualifications; track q; let i = $index) {
          <div class="qual-row">
            <div class="row g-2 align-items-center">
              <div class="qual-num">{{ i + 1 }}</div>
              <div class="col-md-3">
                <input type="text" class="form-control form-control-sm" [name]="'degree'+i" [(ngModel)]="q.degree"
                  placeholder="Degree (e.g. B.Ed, M.Sc)" maxlength="60">
              </div>
              <div class="col-md-4">
                <input type="text" class="form-control form-control-sm" [name]="'qsub'+i" [(ngModel)]="q.subject"
                  placeholder="Subject / Specialisation" maxlength="80">
              </div>
              <!-- <div class="col-md-3">
                <input type="text" class="form-control form-control-sm" [name]="'inst'+i" [(ngModel)]="q.institution"
                  placeholder="University / Institution" maxlength="120">
              </div> -->
              <div class="col-md-2">
                <input type="number" class="form-control form-control-sm" [name]="'yop'+i" [(ngModel)]="q.yearOfPassing"
                  min="1970" max="2030" placeholder="Year">
              </div>
              <div style="width: 110px;">
                <div class="input-group input-group-sm">
                  <input type="number" class="form-control" [name]="'pct'+i" [(ngModel)]="q.percentage" min="0"
                    max="100" placeholder="%">
                  <span class="input-group-text">%</span>
                </div>
              </div>
              <div class="col-auto">
                <button type="button" class="btn-remove-qual" (click)="removeQualification(i)"
                  [disabled]="frmData.qualifications.length === 1">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
          }
          <button type="button" class="btn btn-add-row mt-2" (click)="addQualification()">
            <i class="bi bi-plus-circle me-1"></i> Add Qualification
          </button>
        </div>
      </div>

      <!-- E. Documents -->
      <div class="form-section-card" *ngIf="user.user_role[0].code!='spr'">
        <div class="fsc-header">
          <i class="bi bi-file-earmark-arrow-up-fill"></i> E. Documents
          <span class="ms-auto badge bg-light text-dark small fw-normal border">PDF / JPG / PNG</span>
        </div>
        <div class="fsc-body">
          <div class="row g-3">
            @for (doc of frmData.documents; track doc; let i = $index) {
            <div class="col-md-4">
              <label class="form-label small">{{ doc.name }}</label>
              <label class="doc-upload-area" [for]="'doc-'+i">
                @if (!doc.fileName) {
                <i class="bi bi-cloud-upload d-block mb-1 fs-5 text-primary"></i>
                <span class="small text-muted">Click to upload</span>
                } @else {
                <i class="bi bi-file-check d-block mb-1 fs-5 text-success"></i>
                <span class="small text-success fw-semibold">{{ doc.fileName }}</span>
                }
                <input type="file" [id]="'doc-'+i" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
                  (change)="onDocFile($event, doc)">
              </label>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- F. Remarks -->
      <div class="form-section-card" *ngIf="user.user_role[0].code!='spr'">
        <div class="fsc-header d-flex justify-content-between">
          <span><i class="bi bi-chat-text-fill"></i> F. Remarks</span>
          <span>{{ frmData.remarks.length }} / 500 Char.</span>
        </div>
        <div class="fsc-body">
          <textarea class="form-control" name="remarks" [(ngModel)]="frmData.remarks" rows="3" maxlength="500"
            placeholder="Any additional notes or remarks about this staff member…"></textarea>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        @if (submitted && !staffForm.valid) {
        <div class="alert alert-danger d-flex align-items-center gap-2 mb-0 py-2">
          <i class="bi bi-exclamation-triangle-fill"></i>
          Please fill all required fields.
        </div>
        }
        <div class="d-flex gap-3">
          <button type="button" class="btn btn-outline-secondary px-5"  data-bs-dismiss="modal" aria-label="Close">Cancel</button>
          <button type="submit" class="btn btn-primary-erp px-5">
            <i class="bi bi-check-circle-fill me-2"></i>
            {{ editingId() !== null ? 'Update Staff' : 'Save Staff' }}
          </button>
        </div>
      </div>

    </div>
  </div>
</form>